module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/cyclebar-df952a9ac6a01485793b5bac1b98f5bb.png";